import { PAY_OFFLINE } from "../../routes";
import customAxios from "../../customAxios";

async function payOffline(props: { serviceId: string; payerType: string }) {
  const thisUrl = PAY_OFFLINE;

  let body: any = {
    ...props,
  };

  // ** ---------------------------------------------------------------------------------------------------------------------
  // ** =====================================================================================================================
  // **                                                      Local Functions
  // ** =====================================================================================================================
  // ** ---------------------------------------------------------------------------------------------------------------------

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({ PAY_OFFLINE: error });
  }
}

export default payOffline;
